import React from "react";
import { Card, makeStyles } from "@material-ui/core";
import ReactECharts from "echarts-for-react";
import "echarts-wordcloud";
import { getRandomColor } from "../../../Utilities/Functions";
import styles from "./styles";

const useStyles = makeStyles(styles);

const WordCloud = (props) => {
  const classes = useStyles();

  const { words, title } = props;

  const processedWords = (words || []).map(item => {
    return {
      ...item,
      name: item["name"] === "United Kingdom of Great Britain and Northern Ireland (the)" ? "United Kingdom" : item["name"]
    }
  });

  const _words = (processedWords || []).map((item) => ({
    ...item,
    textStyle: {
      color: getRandomColor(),
    },
  }));

  const options = {
    tooltip: {
      show: true,
    },
    title: {
      text: title,
    },
    series: [
      {
        type: "wordCloud",
        shape: "circle",
        left: 0,
        right: 0,
        top: 0,
        right: 0,
        width: "100%",
        height: "100%",
        gridSize: 0,
        sizeRange: [20, 80],
        drawOutOfBound: true,
        rotationRange: [0, 0],
        emphasis: {
          shadowBlur: 2,
          shadowColor: "#000",
        },
        data: _words,
      },
    ],
  };

  return (
    <Card className={classes.container} variant="outlined" elevation={0}>
      <ReactECharts option={options} />
    </Card>
  );
};

export default WordCloud;
